import React, { useRef, useState, useEffect } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import makeRequest from 'utils/makeRequest';
import _get from 'lodash.get';
import AdCaller from 'helpers/ads/adCaller';
import dateFormat from 'date-fns/format';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import { processPerpectualATFadSticky } from 'helpers/ads/AdObserver';
import { fireGA4Script, isTablet } from 'utils/common';
import { UNIFIED_FEED_DOMAIN } from 'constants/index';
import WithCommentLoader from 'modules/WithComments/WithCommentLoader';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import ErrorBoundary from 'components/ErrorBoundary';
import PhotoSliderWrappr from 'components_v2/desktop/PhotoSliderWrappr/PhotoSliderWrappr';
import TrendingSlider from 'components_v2/desktop/TrendingSlider/TrendingSlider';
// import TimesPointHeaderWidget from 'routes/articleshow_v2/components/desktop/TimesPointHeaderWidget';
import Byline from 'routes/articleshow_v2/components/common/Byline';
import EmailPrintFontOptions from 'routes/articleshow_v2/components/common/EmailPrintFontOptions';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import Sidebar from 'components_v2/desktop/Sidebar';
import Links from 'components/Link';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import WithVisualStories from '../../../home/components/desktop/VisualStories/VisualStories';
import sidebarMapping from './SidebarMapping';
import PhotostoryCard from '../../components/PhotostoryCard/PhotostoryCard';
import s from './Photostory.scss';
import IFrameWdt from '../../../../components_v2/common/IFrameWdt/IFrameWdt';
import validLifeStyleSectionMSIDsForShopTheLook from '../../components/STLButton/constant';

const Photostory = props => {
  const {
    photostoryData,
    msid,
    isPerpetual,
    isUserPrime,
    isEtimesPhotostory,
    topSearches,
    breadCrumbData,
    breadCrumbTitle,
    sectionName,
    sidebarData,
    rhsWidgetPriorityPS,
    bottomWidgets,
    earnPoints,
    user,
  } = props;

  const { navsubsecs = {} } = photostoryData;
  const {
    subsec2: { subsecmsid: subesec2Msid } = {},
    subsec1: { seolocation1: subsec1SeoLocation } = {},
  } = navsubsecs;

  const adConfig = {
    tn: 'ad',
    adtype: 'dfp',
  };

  const articleshowRef = useRef();
  // const timespointRef = useRef();
  const commentTextInput = useRef();
  const userDataRef = useRef(user);
  const loader = useRef(null);
  const atfDivRef = useRef(null);

  const [showSocialWidget, setShowSocialWidget] = useState(false);
  const [page, setPage] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [photos, setPhotos] = useState(
    photostoryData && Array.isArray(photostoryData.items)
      ? photostoryData.items
      : [],
  );

  const totalPhotos =
    photostoryData && photostoryData.pg && photostoryData.pg.cnt;
  const bylineAuthor =
    photostoryData?.audetails?.primary || photostoryData?.audetails?.secondary
      ? new Array(1).fill(
          photostoryData.audetails.primary ||
            photostoryData.audetails.secondary,
        )
      : '';

  const modifiedTime = photostoryData.pwa_meta && photostoryData.pwa_meta.luseo;
  const publishedTime =
    photostoryData.pwa_meta && photostoryData.pwa_meta.dlseo;
  const updStr = modifiedTime
    ? `${dateFormat(new Date(modifiedTime), 'MMM D, YYYY, H:mm')} IST`
    : '';
  const dlStr = publishedTime
    ? `${dateFormat(new Date(publishedTime), 'MMM D, YYYY, H:mm')} IST`
    : '';

  const atfAdCode = () => {
    const { articleIndex, isAdRemoved } = props;
    if (articleIndex > 0 && !isAdRemoved && !isTablet()) {
      return (
        <div className={`${s.ad_fixplaceholder}`} ref={atfDivRef}>
          <AdCaller
            deviceType=""
            data={{
              name: 'masthead',
              ...adConfig,
              articleIndex,
              divId: `${msid}-perpetual-atf`,
            }}
            className={`${s.atf_ad_perpetual} atf_ad_perpetual`}
            immediateLoad
          />
        </div>
      );
    }
    return null;
  };

  useEffect(
    () => {
      userDataRef.current = user;
    },
    [user],
  );

  // eslint-disable-next-line no-unused-vars
  const fetchPhotos = async () => {
    const url = `${UNIFIED_FEED_DOMAIN}/wufs/feed/show/photo?pc=toi&dm=t&msid=${msid}&client=toi&pp=20&cp=${page}`;
    setShowLoader(true);
    makeRequest
      .get(url, { isMobile: false }, 'skipfeedengine')
      .catch(err => {
        console.log(err);
        setShowLoader(false);
      })
      .then(data => {
        if (
          data &&
          data.status === 200 &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length
        ) {
          setPhotos(prev => [...prev, ...data.data.items]);
        }
        setShowLoader(false);
      });
    // setPhotos(prev => [...prev, ...response.data.photos]);
  };

  const handleObserver = entities => {
    const target = entities[0];
    if (
      target.isIntersecting &&
      Array.isArray(photos) &&
      photos.length < totalPhotos
    ) {
      setPage(prev => prev + 1);
    }
  };

  const bottomWidgetsGaOnLoad = () => {
    if (bottomWidgets?.length) {
      bottomWidgets.forEach(widgets => {
        if (widgets?.gaType === 'onload') {
          analyticsWrapper('ga4', widgets.gaData);
        }
        if (widgets?.gaReTrigger) {
          setTimeout(() => {
            analyticsWrapper('ga4', widgets.gaData);
          }, widgets.gaReTrigger);
        }
      });
    }
  };

  useEffect(
    () => {
      if (page > 1) {
        fetchPhotos();
      }
    },
    [page],
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '500px',
      threshold: 0,
    };
    bottomWidgetsGaOnLoad();
    const observer = new IntersectionObserver(handleObserver, option);
    if (loader.current) observer.observe(loader.current);

    if (!isUserPrime && props.articleIndex && atfDivRef) {
      processPerpectualATFadSticky(atfDivRef);
    }

    // Cleanup function to unobserve when component unmounts
    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, []);

  const getPhotostoriesWidget = () => {
    const widget = props.photostoryWidget;
    if (!(widget && Array.isArray(widget.items) && widget.items.length > 0)) {
      return null;
    }

    return (
      <ErrorBoundary>
        <InViewObserver
          inViewCallback={() => {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: widget?.ga4Type ? widget?.ga4Type : 'photostories_widget',
            });
          }}
        >
          <PhotoSliderWrappr
            sectionData={widget}
            slidesToShow={3}
            draggableSlider
            enableBottomArrows
            isFromEtimesPS={isEtimesPhotostory}
            wrapperClass="photostory_slider"
            ga4Type={widget?.ga4Type}
          />
        </InViewObserver>
      </ErrorBoundary>
    );
  };
  const getBiggBossWidget = () => {
    const matchingWidgets = []; // Array to store matching widgets
    if (Array.isArray(bottomWidgets) && bottomWidgets.length) {
      for (let i = 0; i < bottomWidgets.length; i += 1) {
        if (
          bottomWidgets[i].tn === 'PhotoStories_widget' &&
          bottomWidgets[i].name === 'Bigg Boss'
        ) {
          // return (
          //   <>
          //     <div>SAURABH</div>
          //     <ElementInView
          //     // gaAction="view-photostories"
          //     // gaLabel={subSecSeoLocation}
          //     >
          //       <InlineCardSlider
          //         isHeadingShown
          //         fromEtimesAS={this.props.isEtimesArticle}
          //         sectionData={widgets[i]}
          //         source="AS"
          //         key="PhotoStories_widget"
          //         border="top"
          //         isClientSide
          //         gaAction="click-photostories"
          //         layout="horizontal"
          //         cardSpan={9}
          //         isCarousel
          //         cardType="card_21"
          //         borderTop
          //       />
          //     </ElementInView>
          //   </>
          // );
          matchingWidgets.push(
            // eslint-disable-next-line react/jsx-no-undef
            <ErrorBoundary>
              <InViewObserver
                // eslint-disable-next-line no-loop-func
                inViewCallback={() => {
                  if (bottomWidgets[i]?.ga4Type) {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: `${bottomWidgets[i]?.ga4Type}`,
                    });
                  }
                }}
              >
                <PhotoSliderWrappr
                  sectionData={bottomWidgets[i]}
                  slidesToShow={4}
                  draggableSlider
                  enableBottomArrows
                  // isFromEtimesAS={this.props.isEtimesArticle}
                  ga4Type={bottomWidgets[i]?.ga4Type}
                />
              </InViewObserver>
            </ErrorBoundary>,
          );
        }
      }
    }
    return (
      <>
        {matchingWidgets &&
        Array.isArray(matchingWidgets) &&
        matchingWidgets.length > 0
          ? matchingWidgets
          : null}
      </>
    );
  };

  const getArticleWidget = () => {
    const widget = props.articleWidget;
    if (!(widget && Array.isArray(widget.items) && widget.items.length > 0)) {
      return null;
    }

    return (
      <ErrorBoundary>
        <InViewObserver
          inViewCallback={() => {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: widget?.ga4Type,
            });
          }}
        >
          <PhotoSliderWrappr
            sectionData={widget}
            slidesToShow={3}
            draggableSlider
            enableBottomArrows
            isFromEtimesPS={isEtimesPhotostory}
            wrapperClass="photostory_slider"
            ga4Type={widget?.ga4Type}
          />
        </InViewObserver>
      </ErrorBoundary>
    );
  };

  const showSocialShareWidget = () => {
    setShowSocialWidget(true);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'articleshow_sticky',
    });
  };

  const hideSocialShareWidget = () => {
    setShowSocialWidget(false);
  };

  const AffiliateRHSWidget = () => {
    const { ag: articleAgencyName, affKeyword } = photostoryData;

    const renderCondition =
      articleAgencyName !== 'Mediawire' &&
      articleAgencyName !== 'SPOTLIGHT' &&
      articleAgencyName !== 'Brandwire';

    return (
      <div id="affiliate_non_msp_rhs_widget">
        {renderCondition && (
          <AffiliatesContentV2
            enableWidgetsOnLoad
            type="toi_widget_slots"
            client="affiliates"
            filters={{
              pagename: 'articleshow',
              keyword: affKeyword,
              sectionl1: subsec1SeoLocation,
            }}
          />
        )}
      </div>
    );
  };
  const isClient = typeof window !== 'undefined';
  // let adCounter = 4;
  // const maxAdCounter = 8;

  return (
    <>
      {/* SRART- Photostory Main Body Wrapper */}
      <div
        className={`${s.main_ASwrapper}`}
        ref={articleshowRef}
        data-font={props.textSize}
        data-articlemsid={msid}
      >
        {props.parentMsid !== msid &&
          photos &&
          photos.length > 0 && (
            <div className={`${s.separator} clearfix`}>
              <i />
              <span>Up Next</span>
            </div>
          )}
        {/* // todo: atf ad code and prime props */}
        {!isUserPrime && atfAdCode()}
        <div
          className={`${s.innerBody} innerbody ${
            isPerpetual ? s.perpetualAS : ''
          }`}
        >
          <div className={s.left}>
            {!isPerpetual && (
              <>
                <BreadCrumb
                  data={breadCrumbData}
                  title={breadCrumbTitle}
                  wrapperClass="breadcrumb"
                  showHomeIcon
                />
                {topSearches &&
                  Array.isArray(topSearches.items) &&
                  topSearches.items.length && (
                    <TrendingSlider
                      topSearches={topSearches.items}
                      title={topSearches?.name}
                    />
                  )}
              </>
            )}
            <div className={s.articleHead_top}>
              <h1 className={`${s.articleHeading}`}>
                <span dangerouslySetInnerHTML={{ __html: photostoryData.hl }} />
              </h1>
              <div className={`${s.byline_action} byline_action`}>
                <Byline
                  ag={
                    photostoryData.agency && photostoryData.agency.name
                      ? photostoryData.agency.name
                      : ''
                  }
                  guestName={photostoryData.guestName || ''}
                  dl={photostoryData.dl || ''}
                  dlStr={dlStr || ''}
                  updStr={updStr || ''}
                  upd={photostoryData.lu}
                  author={bylineAuthor}
                  isWapView={props.isWapView}
                  sClassName="byline"
                  navSubsection={props.navsubsecs && props.navsubsecs.subsec2}
                />

                <div
                  className={`${s.articleAction_wrapper}`}
                  data-socialshare={msid}
                >
                  <div className={s.left}>
                    <React.Fragment>
                      <div className={`${s.inneraction}`}>
                        {/* <div
                          data-socialshare={msid}
                          ref={timespointRef}
                          className="tp_widget_as"
                        >
                          <TimesPointHeaderWidget
                            msid={msid}
                            title={photostoryData.hl}
                            url={photostoryData.su || photostoryData.wu}
                            wu={photostoryData.wu}
                            isParent
                            via={photostoryData.via}
                            textRequired={false}
                            tpShow
                            linkeDin
                            isWapView={false}
                            gaCategory={props.categoryForGA}
                            gaAction="click"
                            gaIndex="atfShare_"
                            isSmallicon
                            isPerpetual={isPerpetual}
                            articleIndex={
                              isPerpetual ? props.articleIndex : null
                            }
                          />
                        </div> */}

                        <div
                          className={`${s.timelineshare} icon_share_wrap`}
                          onMouseEnter={showSocialShareWidget}
                          onMouseLeave={hideSocialShareWidget}
                        >
                          <div className={`${s.icon_share}`}>
                            <i
                              className={`${s.shareicon} ${
                                showSocialWidget ? s.active : ''
                              }`}
                            />
                            <span>Share</span>
                          </div>

                          {showSocialWidget && (
                            <LoadableComponentLoader
                              loadOnScroll
                              loadableComponentName="SocialSharingWeb"
                              msid={msid}
                              isParent={msid === props.parentMsid}
                              url={photostoryData.su || photostoryData.wu}
                              title={photostoryData.hl}
                              className={s.icon_hover_social}
                              isWapView={false}
                              isSmallicon
                              image={
                                photostoryData.images
                                  ? photostoryData.images[0]
                                  : undefined
                              }
                              // image={
                              //   photostoryData.it
                              //     ? {
                              //         id: photostoryData.it.id,
                              //         imagesize: photostoryData.it.imgsize,
                              //         cap: photostoryData.it.cap,
                              //       }
                              //     : undefined
                              // }
                              openSidebar={props.openSidebar}
                              commentsCount={props.commentsCount}
                              wu={photostoryData.wu}
                              via={photostoryData.via || '@timesofindia'}
                              isTablet={props.isTablet}
                              // commentModeration={commentModerationVal}
                              type="ATF"
                              // gaCategory={categoryForGA}
                              gaAction="click"
                              gaIndex="atfShare_"
                              textRequired={false}
                              linkeDin
                              sectionName={
                                typeof sectionName === 'string'
                                  ? sectionName.toLowerCase()
                                  : ''
                              }
                            />
                          )}
                        </div>

                        <EmailPrintFontOptions
                          msid={msid}
                          url={photostoryData.wu}
                          title={photostoryData.hl}
                          changeSize={props.onSizeChange}
                          textSize={props.textSize}
                          showFontAlterOptions={props.showFontAlterOptions}
                          // gaCategory={categoryForGA}
                          hidePrintOption
                          gaAction="click"
                          gaLabel="atf"
                        />
                      </div>
                      <div className={`${s.gnews_top}`}>
                        <Links
                          href={
                            isEtimesPhotostory
                              ? 'https://news.google.com/publications/CAAqBwgKMKrsugswt4fSAw'
                              : 'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag'
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => {
                            analyticsWrapper('ga4', {
                              event: 'user_click',
                              type: 'follow_google_news',
                              category: 'articleshow_sticky',
                            });
                          }}
                        >
                          Follow us <i />
                        </Links>
                      </div>
                    </React.Fragment>
                  </div>
                </div>
              </div>
            </div>
            <div className="clearfix" />
            <div className={s.left_inner_ps}>
              <div className={`${s.articlebody}`}>
                <div
                  data-articlebody="1"
                  // ref={myRef => {
                  //   articleBodyRef = myRef;
                  // }}
                  className={`fewcent-${msid}`}
                >
                  <div className={`${s.article_content} clearfix `}>
                    {Array.isArray(photos) &&
                      photos.map((photo, index) => {
                        const cardComponent = (
                          <InViewObserver
                            doNotUnobserve
                            thresholdMargin={0.7}
                            user={user}
                            inViewCallback={() => {
                              if (photo.id) {
                                // Parse the original URL
                                const url = new URL(window.location.href);

                                // Get current search parameters
                                const urlSearchParams = url.searchParams;

                                // Check if 'picid' parameter exists and update it or add it
                                if (index > 0) {
                                  if (urlSearchParams.has('picid')) {
                                    // Update existing 'picid'
                                    urlSearchParams.set('picid', photo.id);
                                  } else {
                                    // Add new 'picid' if it doesn't exist
                                    urlSearchParams.append('picid', photo.id);
                                  }
                                } else if (
                                  index === 0 &&
                                  urlSearchParams.has('picid')
                                ) {
                                  urlSearchParams.delete('picid');
                                }

                                // Generate the new URL (seourl) with updated or added 'picid'
                                const seourl = url.toString();

                                window.history.replaceState(
                                  {},
                                  index === 0
                                    ? photostoryData.hl
                                    : `${photo.hl}-${photostoryData.hl}`,
                                  seourl,
                                );

                                const htmltagsRegex = /(<([^>]+)>)/gi;
                                let docTitle =
                                  index === 0
                                    ? photostoryData.hl
                                    : `${photo.hl}-${photostoryData.hl}`;
                                if (typeof docTitle === 'string') {
                                  docTitle = docTitle.replace(
                                    htmltagsRegex,
                                    '',
                                  );
                                }

                                if (index === 4) {
                                  const currentUserData = userDataRef.current;
                                  if (
                                    currentUserData &&
                                    currentUserData.isLoggedIn &&
                                    earnPoints &&
                                    typeof earnPoints === 'function'
                                  ) {
                                    earnPoints({
                                      msid,
                                      actType: 'PHOTO_STORY',
                                      ssoid: currentUserData.getUid(),
                                      phoneNumber: currentUserData?.getMobile()
                                        ?.Verified?.mobile,
                                    });
                                  }
                                }

                                if (index > 0 || (index === 0 && isPerpetual)) {
                                  // fireGA4Script(msid, props.articleIndex, {
                                  //   photoNumber: index + 1,
                                  // });
                                  document.title = docTitle;
                                  const dayssincecreated = photostoryData?.dl;
                                  fireGA4Script({
                                    vmsid: msid,
                                    storyNumber: props.articleIndex,
                                    dayssincecreated,
                                    params: {
                                      photoNumber: index + 1,
                                    },
                                  });
                                  // analyticsWrapper(
                                  //   'ga',
                                  //   'send',
                                  //   'pageview',
                                  //   photostoryData?.wu,
                                  // );
                                }
                              }
                            }}
                          >
                            <div className={s.listItem}>
                              <PhotostoryCard
                                showShopTheLookButton={validLifeStyleSectionMSIDsForShopTheLook.includes(
                                  subesec2Msid,
                                )}
                                data={photo}
                                count={index + 1}
                                totalCount={totalPhotos || photos.length}
                                textSize={props.textSize}
                              />
                            </div>
                          </InViewObserver>
                        );

                        let adComponent = null;
                        if (index === 0 && !isUserPrime) {
                          adComponent = (
                            <AdCaller
                              data={{
                                jname: 'inline_custom_mid_ad',
                                articleIndex: props.articleIndex,
                              }}
                              msid={`${photo.id}-${index}-apv`}
                              immediateLoad
                              adWapperClass={s.apvWrapper}
                            />
                          );
                        }

                        if ((index + 1) % 3 === 0 && !isUserPrime) {
                          adComponent = (
                            <div className={s.mid_ads}>
                              <AdCaller
                                data={{
                                  jname: 'mid',
                                  articleIndex: props.articleIndex,
                                }}
                                msid={`${photo.id}-${index}-m1`}
                                immediateLoad
                                adWapperClass="ad"
                                inPlaceholder="adplaceholder"
                              />

                              <AdCaller
                                data={{
                                  jname: 'mid1',
                                  articleIndex: props.articleIndex,
                                }}
                                msid={`${photo.id}-${index}-m2`}
                                adWapperClass={s.ad_right}
                                inPlaceholder="adplaceholder"
                                immediateLoad
                              />
                            </div>
                          );
                          // adComponent = (
                          //   <div
                          //     className={`leaderboard_placeHolder ${
                          //       s.leaderBoardAd
                          //     }`}
                          //   >
                          //     <div className="lbAd">
                          //       <AdCaller
                          //         data={{
                          //           ...adConfig,
                          //           name: adName,
                          //         }}
                          //         msid={`${photo.id}-${index}`}
                          //         immediateLoad
                          //       />
                          //     </div>
                          //   </div>
                          // );
                        }
                        return (
                          <>
                            {cardComponent}
                            {adComponent}
                          </>
                        );
                      })}
                    <div ref={loader} />
                    {showLoader && (
                      <div className={s.loader}>
                        <LoaderSpinner overwriteWrapper={s.loader} />
                      </div>
                    )}
                  </div>
                </div>
                {!props.isTablet() &&
                  !props.isAppView && (
                    <LoadableComponentLoader
                      loadInView
                      loadableComponentName="TopComment"
                      msid={msid}
                      onSidebarOpenClose={props.openSideBar}
                      commentsData={props.commentsData}
                      commentsCount={props.commentsCount}
                      isWapView={false}
                      isTablet={props.isTablet}
                      isPrivateUser={props.isPrivateUser}
                      commentModeration={_get(
                        photostoryData,
                        'metaInfo.CommentModeration',
                        '',
                      )}
                      commentTextInput={commentTextInput}
                      // gaCategory={categoryForGA}
                      isEtimesArticle={isEtimesPhotostory}
                      placeHolderStyles={{ minHeight: '160px' }}
                    />
                  )}
                {props.isTablet() && (
                  <WithCommentLoader
                    msid={msid}
                    isWapView={props.isWapView}
                    commentTextInputRef={commentTextInput}
                    seoData={photostoryData.seo}
                    commentModeration={_get(
                      photostoryData,
                      'metaInfo.CommentModeration',
                      '',
                    )}
                  />
                )}
                <div
                  className={s.bottom_socialwidget}
                  data-bottomsocialshare={msid}
                >
                  <span className={s.inlineshare_heading}>
                    Follow Us On Social Media
                  </span>
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="SocialSharingWeb"
                    hideSharingButtons
                    showFollowButtons
                    isWapView={false}
                    isTablet={props.isTablet}
                    type="BTF"
                    // gaCategory={categoryForGA}
                    gaAction="click"
                    gaIndex="btfFollow_"
                    textRequired
                    sectionName={
                      typeof sectionName === 'string'
                        ? sectionName.toLowerCase()
                        : ''
                    }
                    isEtimes={isEtimesPhotostory}
                    placeHolderStyles={{ minHeight: '24px' }}
                    placeHolderLoaderClass="follow_us_loader"
                  />
                </div>
                <>
                  {Array.isArray(bottomWidgets) &&
                    bottomWidgets.length &&
                    bottomWidgets.map(widget => {
                      switch (widget.tn) {
                        case 'visual_stories':
                          return (
                            <WithVisualStories
                              sectionData={{
                                name: widget.title,
                                items: widget.items,
                              }}
                              cardWrapperClass="visualstoriesas"
                              // clickGaAction={
                              //   this.props.isEtimesArticle
                              //     ? 'click-visual-stories'
                              //     : 'click_visualstory'
                              // }
                              // gaLabelConnector={this.props.isEtimesArticle ? '-' : ''}
                              // isEtimesArticle={this.props.isEtimesArticle}
                              disableIsLarge
                            />
                          );
                        case 'iframe':
                          return <IFrameWdt {...widget} key={widget.tn} lazy />;
                        default:
                          return null;
                      }
                    })}
                  {getArticleWidget()}
                  {getBiggBossWidget()}
                  {getPhotostoriesWidget()}
                </>
              </div>
            </div>
          </div>

          <div className={`${s.right} article_rhs`}>
            <Sidebar
              data={sidebarData}
              rhsWidgetPriority={rhsWidgetPriorityPS}
              msid={msid}
              currentCountry={props.currentCountry}
              // breadCrumbString={breadCrumbString}
              gaPrefix="RHS"
              sidebarMapping={sidebarMapping}
              // widgetCss={s.widgetPadding}
              // gaCategory={categoryForGA}
              articleIndex={props.articleIndex}
              gaAction="click"
              gaLabel=""
              // secName={this.getSectionName()}
              isUserPrime={isUserPrime}
              AffiliateRHSWidget={AffiliateRHSWidget()}
              stickySideBarClasses={{
                sticky: s.stickySidebar,
                stickyWithoutHeader: s.stickySidebarWithoutHeader,
              }}
              isRHSWidgetPS // todo: change in widgets
              // rhsWidgetVideoAS={props.rhsWidgetVideoAS}
              // subSecSeoLocation={subSecSeoLocation}
              isPerpetual={isPerpetual}
              pageUrl={photostoryData.wu}
              isEtimes={isEtimesPhotostory}
              rhsWidgetVideoAS={props.rhsWidgetVideoAutoplay}
            />
          </div>
        </div>
        {/* <div id={`liner-${articleshowData.id}`} /> */}
      </div>
      {/* END - Photostory Main Body Wrapper */}

      <div className={`${s.main_content} clearfix`}>
        {!props.isTablet() && (
          <div id={`comment-sidebar-${msid}`}>
            <PopupPortal usePopupPortal={isClient}>
              <WithCommentLoader
                msid={msid}
                isWapView={props.isWapView}
                commentTextInputRef={commentTextInput}
                seoData={photostoryData.seo}
                commentModeration={_get(
                  photostoryData,
                  'metaInfo.CommentModeration',
                  '',
                )}
                hideBottomComments
              />
            </PopupPortal>
          </div>
        )}
        <div data-articlepage-end={msid} />
      </div>
      {/* {this.state.onScrollScripts.size !== 0 && (
        <LoadableComponentLoader
          loadOnScroll
          loadableComponentName="ScriptLoader"
          scripts={this.state.onScrollScripts}
        />
      )} */}
    </>
  );
};

export default Photostory;
